import { render, staticRenderFns } from "./order_list.vue?vue&type=template&id=0b17a702&scoped=true"
import script from "./order_list.vue?vue&type=script&lang=js"
export * from "./order_list.vue?vue&type=script&lang=js"
import style0 from "./order_list.vue?vue&type=style&index=0&id=0b17a702&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b17a702",
  null
  
)

export default component.exports